import type { BaseColour } from '~types';

/** Predefined base colours in OKLCH space for visualizations */
export const BASE_COLOURS: Record<string, BaseColour> = {
  BLUE: { l: 0.6, c: 0.15, h: 220 },
  TEAL: { l: 0.6, c: 0.18, h: 185 },
  GREEN: { l: 0.6, c: 0.16, h: 145 },
  PURPLE: { l: 0.6, c: 0.2, h: 280 },
  ORANGE: { l: 0.65, c: 0.18, h: 60 },
  RED: { l: 0.6, c: 0.2, h: 10 },
  YELLOW: { l: 0.75, c: 0.15, h: 90 },
  PINK: { l: 0.7, c: 0.2, h: 320 },
  BROWN: { l: 0.55, c: 0.18, h: 40 },
  GREY: { l: 0.5, c: 0.05, h: 0 },
} as const;
